export default async function ({ path, state, api }) {
    const id = state.get('app.id');

    try {
        const response = await api.get(`/state/${id}`, {});
        const { data } = JSON.parse(response.data);
        const answers = JSON.parse(data);
        state.set('app.answers', answers || {});

        return path.success({});
    } catch (error) {
        return path.error({ error });
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/fetchState.js